import React from 'react';
import Carousel from 'react-material-ui-carousel'
import V2InstructorCard from './v2InstructorCard';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { fadeInLeft, fadeInRight } from '../../animations/motionConfigs'
import Instructor1 from '../../../components/images/Instructor1.webp';
import Instructor2 from '../../../components/images/Instructor2.webp';
import Instructor3 from '../../../components/images/Instructor3.webp';
import Instructor4 from '../../../components/images/Instructor4.webp';

function V2InstructorContent(props) {
    const { isSmallScreen, setValue } = props;

    const ref = React.useRef(null);

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setValue(3);
                }
            },
            { threshold: 0.9 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);

    var itemsWeb = [
        [
            {
                id: 1,
                name: "Puneet Kumar Bhatia",
                title: "Microsoft Certified Trainer",
                description:
                    "20 years of experience in IT with expertise in Requirement Analysis, Product Development & Testing (QA), Delivery/Release management, DevOps practices, cloud computing, requirement analysis, Software project/product life cycle implementation and Agile Methodologies.",
                image: "https://media.licdn.com/dms/image/v2/C5603AQHrbmCdtTb2xA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1590382473746?e=2147483647&v=beta&t=6ZddQ8t-EkfgQeMvYMzHO6CwvZri-EqZII2XoZq6gVI",
            },
            {
                id: 2,
                name: "Ritvik Saxena",
                title: "Microsoft Certified Trainer",
                description:
                    "Ritvik Saxena, an experienced AWS Cloud and DevOps Trainer, is dedicated to empowering learners with industry-ready skills through hands-on training in AWS, DevOps tools, automation, and cloud technologies, bridging the gap between theory and practice.",
                image: Instructor1,
            },
            {
                id: 3,
                name: "Tanvi Puri",
                title: "Microsoft Certified Trainer",
                description:
                    "Tanvi is highly motivated DevOps Enthusiast with extensive experience in automating software development lifecycles using Azure DevOps, Docker, Kubernetes, and Ansible. Proven ability to design, implement, and manage CI/CD pipelines for efficient app delivery",
                image: Instructor2,
            },
        ],
        [
            {
                id: 4,
                name: "Aneesh Kumar",
                title: "Microsoft Certified Trainer",
                description:
                    "Aneesh is a certified IT expert in AWS and Azure, working as a DevOps Architect and specializing in cloud and infrastructure. He designs and builds entire IT setups for important apps in banking, insurance, and finance.",
                image: Instructor3,
            },
            {
                id: 5,
                name: "Arun Raju",
                title: "Microsoft Certified Trainer",
                description:
                    "Arun Raju, a DevOps Engineer and Trainer, excels in building scalable, automated, and secure infrastructure. He specializes in Linux, Shell Scripting, Git, Jenkins, Docker, Terraform, and Ansible, empowering teams with practical, hands-on DevOps expertise.",
                image: Instructor4,
            },
            {
                id: 6,
                name:  "Loksai",
                title: "Microsoft Certified Trainer",
                description:
                    "Loksai, a DevOps Architect and Trainer, specializes in GIT, AWS DevOps, Azure DevOps, Kubernetes, ArgoCD, Docker, Terraform, Ansible, and Jenkins, providing hands-on training to streamline CI/CD pipelines and automate infrastructure.",
                image: "https://i.pinimg.com/736x/e6/a3/d5/e6a3d52959a90ec96aaefd5276a41de2.jpg",
            },
        ],
        [
            {
                id: 7,
                name: "Kastro Kiran",
                title: "Microsoft Certified Trainer",
                description:
                    "With 8+ years in Structural and Construction Engineering, He specializes in self-curing concrete, ML for shrinkage prediction, AWS Cloud, DevOps tools, corporate training, and academia-industry collaboration, delivering practical and innovative solutions.",
                image: "https://media.licdn.com/dms/image/v2/D5603AQHJB_lF1d9OSw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1718971147142?e=2147483647&v=beta&t=bH5cPcsE5TGh7h6qiC013cDOft-X3k2qFYO0mAmo7nI",
            },
            {
                id: 8,
                name: "Gareth Ruhan",
                title: "Microsoft Certified Trainer",
                description:
                    "Gareth Ruhan, a certified Cloud Consultant and Microsoft Certified Trainer (MCT), specializes in Azure technologies. He delivers training and implements data solutions and DevOps projects using Azure services, with expertise in Azure Data, DevOps, and Power BI.",
                image: "https://media.licdn.com/dms/image/v2/D4D03AQHzi6_ozDYR7w/profile-displayphoto-shrink_200_200/B4DZXSfa_EHAAY-/0/1742993207806?e=2147483647&v=beta&t=KQNmhOpVCROoqVTG9MkVVUgkz-sA25CVqePl6hSCjeY"
            },
            {
                id: 1,
                name: "Puneet Kumar Bhatia",
                title: "Microsoft Certified Trainer",
                description:
                    "20 years of experience in IT with expertise in Requirement Analysis, Product Development & Testing (QA), Delivery/Release management, DevOps practices, cloud computing, requirement analysis, Software project/product life cycle implementation and Agile Methodologies.",
                image: "https://media.licdn.com/dms/image/v2/C5603AQHrbmCdtTb2xA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1590382473746?e=2147483647&v=beta&t=6ZddQ8t-EkfgQeMvYMzHO6CwvZri-EqZII2XoZq6gVI",
            },
        ]
    ];

    var itemsMobile =
        [
            {
                id: 1,
                name: "Puneet Kumar Bhatia",
                title: "Microsoft Certified Trainer",
                description:
                    "20 years of experience in IT with expertise in Requirement Analysis, Product Development & Testing (QA), Delivery/Release management, DevOps practices, cloud computing, requirement analysis, Software project/product life cycle implementation and Agile Methodologies.",
                image: "https://media.licdn.com/dms/image/v2/C5603AQHrbmCdtTb2xA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1590382473746?e=2147483647&v=beta&t=6ZddQ8t-EkfgQeMvYMzHO6CwvZri-EqZII2XoZq6gVI",
            },
            {
                id: 2,
                name: "Ritvik Saxena",
                title: "Microsoft Certified Trainer",
                description:
                    "Ritvik Saxena, an experienced AWS Cloud and DevOps Trainer, is dedicated to empowering learners with industry-ready skills through hands-on training in AWS, DevOps tools, automation, and cloud technologies, bridging the gap between theory and practice.",
                image: Instructor1,
            },
            {
                id: 3,
                name: "Tanvi Puri",
                title: "Microsoft Certified Trainer",
                description:
                    "Tanvi is highly motivated DevOps Enthusiast with extensive experience in automating software development lifecycles using Azure DevOps, Docker, Kubernetes, and Ansible. Proven ability to design, implement, and manage CI/CD pipelines for efficient app delivery",
                image: Instructor2,
            },
            {
                id: 4,
                name: "Aneesh Kumar",
                title: "Microsoft Certified Trainer",
                description:
                    "Aneesh is a certified IT expert in AWS and Azure, working as a DevOps Architect and specializing in cloud and infrastructure. He designs and builds entire IT setups for important apps in banking, insurance, and finance.",
                image: Instructor3,
            },
            {
                id: 5,
                name: "Arun Raju",
                title: "Microsoft Certified Trainer",
                description:
                    "Arun Raju, a DevOps Engineer and Trainer, excels in building scalable, automated, and secure infrastructure. He specializes in Linux, Shell Scripting, Git, Jenkins, Docker, Terraform, and Ansible, empowering teams with practical, hands-on DevOps expertise.",
                image: Instructor4,
            },
            {
                id: 6,
                name:  "Loksai",
                title: "Microsoft Certified Trainer",
                description:
                    "Loksai, a DevOps Architect and Trainer, specializes in GIT, AWS DevOps, Azure DevOps, Kubernetes, ArgoCD, Docker, Terraform, Ansible, and Jenkins, providing hands-on training to streamline CI/CD pipelines and automate infrastructure.",
                image: "https://i.pinimg.com/736x/e6/a3/d5/e6a3d52959a90ec96aaefd5276a41de2.jpg",
            },
            {
                id: 7,
                name: "Kastro Kiran",
                title: "Microsoft Certified Trainer",
                description:
                    "With 8+ years in Structural and Construction Engineering, He specializes in self-curing concrete, ML for shrinkage prediction, AWS Cloud, DevOps tools, corporate training, and academia-industry collaboration, delivering practical and innovative solutions.",
                image: "https://media.licdn.com/dms/image/v2/D5603AQHJB_lF1d9OSw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1718971147142?e=2147483647&v=beta&t=bH5cPcsE5TGh7h6qiC013cDOft-X3k2qFYO0mAmo7nI",
            },
            {
                id: 8,
                name: "Gareth Ruhan",
                title: "Microsoft Certified Trainer",
                description:
                    "Gareth Ruhan, a certified Cloud Consultant and Microsoft Certified Trainer (MCT), specializes in Azure technologies. He delivers training and implements data solutions and DevOps projects using Azure services, with expertise in Azure Data, DevOps, and Power BI.",
                image: "https://media.licdn.com/dms/image/v2/D4D03AQHzi6_ozDYR7w/profile-displayphoto-shrink_200_200/B4DZXSfa_EHAAY-/0/1742993207806?e=2147483647&v=beta&t=KQNmhOpVCROoqVTG9MkVVUgkz-sA25CVqePl6hSCjeY"
            },
        ];

    return (
        <motion.div {...fadeInLeft} style={{ width: isSmallScreen? "90%" : "75%", margin: "1rem auto" }}>
            <Typography
                variant="h4"
                sx={{
                    fontWeight: 800,
                    mb: isSmallScreen? 5 : 5,
                    textAlign: "left",
                    fontFamily: "inherit",
                    padding: isSmallScreen? "0" : "0 2rem",
                    mt: isSmallScreen && "2rem",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: isSmallScreen && "1.5rem",
                }}
            >
                Our Instructors
            </Typography>
            {
                isSmallScreen
                    ?
                    <Carousel
                        animation={"slide"}
                        autoPlay="false"
                        navButtonsAlwaysVisible="true"
                        interval={400000}
                    >
                        {
                            itemsMobile.map((item, itemIndex) =>
                                <CarouselCard key={itemIndex} item={item} isSmallScreen={isSmallScreen} />
                            )
                        }
                    </Carousel>
                    :
                    <Carousel
                        animation={"slide"}
                        autoPlay="false"
                        navButtonsAlwaysVisible="true"
                        interval={400000}
                    >
                        {
                            itemsWeb.map((group, groupIndex) =>
                                <Item key={groupIndex} group={group} />
                            )
                        }
                    </Carousel>
            }
        </motion.div>
    )
}

function Item(props) {
    const { group } = props;

    return (
        <div style={{ display: "flex", margin: "auto 10px" }}>
            {group.map((item, itemIndex) => (
                <CarouselCard item={item} />
            ))}
        </div>
    )
}

function CarouselCard(props) {
    const { item, isSmallScreen } = props;


    return (
        <V2InstructorCard
            isSmallScreen={isSmallScreen}
            title={item.title}
            name={item.name}
            description={item.description}
            image={item.image}
            id={item.id}
        />
    )
}

export default V2InstructorContent;